module.exports = __webpack_public_path__ + "img/platinum_plus_logo.46474013.webp";